import { CabecalhoDaTela, PainelDaAba, useAbaAtual, type Aba } from "../componentes/Abas.js";
import { IconeAjustes, IconeConta, IconeIa } from "../componentes/icones.js";
import { Ajustes } from "./Ajustes.js";
import { AjustesDaIa } from "./AjustesDaIa.js";
import { Conta } from "./Conta.js";

/**
 * Ajustes e conta (RN-30).
 *
 * `/conta` era rota registrada e **invisível**: não aparecia em nenhuma lista da
 * navegação, e só se chegava nela por um link dentro de Ajustes. Como aba, ela
 * passa a existir na tela em que já se esperava encontrá-la, sem ganhar um
 * destino próprio numa barra que já tinha destinos demais.
 *
 * A aba da IA deixou de se chamar só "IA". Duas letras num alvo de navegação
 * dizem que existe algo sobre o assunto, não o que se faz ali — e esta era a
 * única porta para configurar o recurso.
 */
const ABAS: readonly Aba[] = [
  {
    id: "preferencias",
    rotulo: "Preferências",
    glifo: IconeAjustes,
    descricao: "Tema, tamanho do texto, modo férias e modo ônibus.",
  },
  {
    id: "conta",
    rotulo: "Conta",
    glifo: IconeConta,
    descricao: "Seu fuso, seu e-mail e onde você está conectado.",
  },
  {
    id: "ia",
    rotulo: "Inteligência artificial",
    glifo: IconeIa,
    descricao: "Onde a inteligência artificial entra no Grifo, e com que chave.",
  },
];

export function Preferencias({ aoSair }: { aoSair: () => void }) {
  const [aba, escolher] = useAbaAtual(ABAS);

  return (
    <>
      <CabecalhoDaTela
        titulo="Ajustes"
        rotulo="Ajustes e conta"
        abas={ABAS}
        atual={aba}
        aoEscolher={escolher}
        estreito
      />
      <PainelDaAba id={aba} className="">
        {aba === "preferencias" && <Ajustes aoSair={aoSair} />}
        {aba === "conta" && <Conta aoSair={aoSair} />}
        {aba === "ia" && (
          <div className="tela tela--painel">
            <div className="tela__corpo">
              <AjustesDaIa />
            </div>
          </div>
        )}
      </PainelDaAba>
    </>
  );
}
